import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]

import { useCheckout } from '@/b2c/checkout/useCheckout';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useNewsletterSubscription } from '@/b2c/checkout/useNewsletterSubscription';
import { ref } from 'vue';
import { useTermsAndConditions } from '@/shared/checkout/useTermsAndConditions';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentFinalizeHasSufficientPayments',
  setup(__props) {

const labels = useBlockLabels();
const { submitOrderWithSufficientPaymentsInBasket, initializePayment, setItemIdsOutOfStock, setEarliestDeliveryDateChanged } = useCheckout();
const { subscribe } = useNewsletterSubscription();
const { trySubmitTerms } = useTermsAndConditions();
const pending = ref<boolean>(false);

const startPayment = async() => {
    const termsAccepted = trySubmitTerms();
    if (!termsAccepted) {
        return;
    }

    const result = await initializePayment();
    if (result.itemsOutOfStock?.length) {
        setItemIdsOutOfStock(result.itemsOutOfStock);
    } else if (result.requiredEarliestDeliveryDate) {
        setEarliestDeliveryDateChanged(true);
    } else {
        pending.value = true;
        await submitOrderWithSufficientPaymentsInBasket(subscribe.value);
        pending.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "c-button c-button--primary",
    disabled: pending.value,
    onClick: _withModifiers(startPayment, ["prevent"])
  }, _toDisplayString(_unref(labels).paymentStepButtonConfirmAndSubmit), 9, _hoisted_1))
}
}

})